import { Component, Prop, Vue } from 'nuxt-property-decorator';
import { ICmsBlock } from '../cms/helpers/renderContent';

@Component
export default class CmsBlockMixin extends Vue {
	@Prop({
		type: Array,
		default() {
			return [];
		},
	})
	blocks!: ICmsBlock[];

	@Prop({
		type: [Array, Object],
		default() {
			return [];
		},
	})
	placeholders!: unknown[] | Record<string, unknown>;

	@Prop({
		type: [Array, Object],
		default() {
			return [];
		},
	})
	content!: unknown[] | Record<string, unknown>;

	@Prop({
		type: [Array, Object],
		default() {
			return [];
		},
	})
	values!: unknown[] | Record<string, unknown>;

	@Prop({
		type: [Array, Object],
		default() {
			return [];
		},
	})
	cfgs!: unknown[] | Record<string, unknown>;

	@Prop({
		type: [Array, Object],
		default() {
			return [];
		},
	})
	extras!: unknown[] | Record<string, unknown>;
}
